export const initialValues = {
    amount: '',
    phone: '',
    first_name: '',
    last_name: '',
    email: '',
    shipping_dest: '',
    planRef: '',
};
